module.exports = __webpack_public_path__ + "img/icon-02-peta-kompas-transparent.c05fbc45.png";